export const getMagentoImage = (file) => {
  if (!file) return "";

  return `https://www.stran.store/media/catalog/product${file}`;
};

export const mapSizeLabel = (valueIndex) => {
  const sizeMap = {
    120: "XS",
    119: "S",
    118: "M",
    117: "L",
    116: "XL",
    166: "2XL",
    167: "3XL",
    168: "4XL"
  };

  return sizeMap[valueIndex] || `Size ${valueIndex}`;
};

export const getSizeFromSku = (sku) => {
  if (!sku) return "";

  const sizePart = sku.split("-").pop();

  const sizeMap = {
    XS: "XS",
    S: "S",
    M: "M",
    L: "L",
    XL: "XL",
    "2XL": "2XL",
    "3XL": "3XL",
    "4XL": "4XL"
  };

  return sizeMap[sizePart] || sizePart;
};